/* eslint-disable import/no-mutable-exports */
import moment from 'moment';
import stringsFr from './strings.fr';
import stringsEn from './strings.en';
import { Language } from '../../core/apiTypes';
import { getLanguage } from '../../utils/language';

export let language: string = getLanguage();
export let stringsRes = language === Language.FR ? stringsFr : stringsEn;

export function setLanguage(newLanguage: Language): void {
    language = newLanguage;
    stringsRes = language === Language.FR ? stringsFr : stringsEn;
    moment.locale(language);
}

export function getLocalError(leCabError: { clientMessage: { fr: string; en: string } }): string {
    return leCabError
        ? (leCabError.clientMessage?.[language] ?? leCabError.clientMessage?.en ?? `No translation for ${language}`)
        : '';
}

export function rps(stringToReplace: string, variables: Record<string, unknown>): string {
    let res = stringToReplace;
    Object.keys(variables).forEach((key) => {
        res = res.replace(`{{${key}}}`, `${variables[key]}`);
    });
    return res;
}
